import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

const Parties: React.FC = () => {
  const [activeTab, setActiveTab] = useState('standard');

  const partyPackages = [
    {
      id: 'standard',
      title: 'Standard Party',
      image: '/party1.jpg',
      color: 'from-stables-500 to-stables-600',
      features: [
        {
          title: 'Horse Rides',
          description: 'Watch your child\'s eyes light up with excitement as they saddle up for a magical horseback journey. Our gentle and friendly horses are ready to make dreams come true.',
        },
        {
          title: 'Lawn Games & Hobby Horses',
          description: 'At The Stables, fun knows no bounds! These fun games are set up around the picnic area: Hobby Horses, Sandbag Toss, Giant Jenga, Tin Knock Over, Connect Four',
        },
        {
          title: 'Set Up Includes',
          description: 'Picnic Tables, Blankets, Bunting Flags, Treats for the horses',
        },
        {
          title: 'Food & Drinks',
          description: 'Seasonal fruit skewers, Pop corn station, Jelly pods, Ice Tea & Water jugs. Pizza Buffet to be ordered for adults & kids. Sodas also available to order.',
        }
      ]
    },
    {
      id: 'farm',
      title: 'Farm Fun Party',
      image: '/party2.jpg',
      color: 'from-stables-400 to-stables-500',
      features: [
        {
          title: 'Boere Sport Games',
          description: 'These games are presented by the guides and horse grooms: Apple Bobbing & Flour Game, Egg & Spoon Race, Waterballoon Throw, Sack racing',
        },
        {
          title: 'Get Your Hands Dirty',
          description: 'Each child gets the opportunity to "be a farmer" and plant a flower or herb plant in a pot to take home. The guides will assist with this activity. Type of plant is subject to seasonal availability.',
        },
        {
          title: 'All Standard Features',
          description: 'Includes everything from the Standard Party Package with these additional farm-themed activities.',
        }
      ]
    },
    {
      id: 'unicorn',
      title: 'Unicorn Party',
      image: '/party3.jpg',
      color: 'from-stables-700 to-stables-800',
      features: [
        {
          title: 'Unicorns!',
          description: 'A few Horses & Ponies dressed up as unicorns - includes horns and rainbow hair. Amount of dressed up equines subject to availability. These horses and ponies won\'t necessarily be available for the rides but children can interact with them.',
        },
        {
          title: 'Cupcake Decorating',
          description: 'Children can decorate their own cupcake as part of the activities.',
        },
        {
          title: 'All Standard Features',
          description: 'Includes everything from the Standard Party Package with these magical unicorn-themed additions.',
        }
      ]
    }
  ];

  const activePackage = partyPackages.find(pkg => pkg.id === activeTab) || partyPackages[0];

  return (
    <div className="min-h-screen">
      <SEO
        title="Stable Parties | Children's Horse Ride & Picnic Parties Pretoria | The Stables"
        description="Book a magical horse ride and picnic party for your child at The Stables, Pretoria East. Standard, Farm Fun and Unicorn party packages available. Enquire today!"
        path="/parties"
        image="https://www.thestableshorserides.co.za/partiesImage.jpg"
      />
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-gradient-to-br from-cream-50 via-stables-50 to-stables-100">
        {/* Background Image */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
          backgroundImage: "url('/partiesImage.jpg')"
        }}></div>
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-transparent"></div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Stable Parties</h1>
          <p className="text-xl md:text-2xl mb-8 font-light">
            We offer fun horse ride & picnic parties that promise a day filled with joy and adventure
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@thestableshorserides.co.za?subject=Stable Party Enquiry"
              className="bg-stables-600 hover:bg-stables-700 text-white px-6 py-3 rounded-lg text-base font-semibold transition-colors duration-300"
            >
              Enquire About a Party
            </a>
            <Link
              to="/horse-rides"
              className="bg-white text-stables-800 hover:bg-stables-100 px-6 py-3 rounded-lg text-base font-semibold transition-colors duration-300"
            >
              View Rides
            </Link>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="py-20 bg-cream-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-stables-800 mb-6">What We Offer</h2>
            <p className="text-xl text-stables-700 max-w-4xl mx-auto leading-relaxed">
              We specialize in creating memorable horse ride and picnic parties that promise a day filled 
              with joy and adventure. Our offerings are designed to delight children, offering them the 
              opportunity to embark on a fun-filled horse ride that's bound to bring smiles and laughter.
            </p>
            <p className="text-xl text-stables-700 max-w-4xl mx-auto leading-relaxed mt-6">
              After their exciting ride, we invite them to indulge in a delicious picnic, complete with 
              yummy treats and a charming setting. It's the perfect combination of outdoor fun and tasty delights.
            </p>
            <p className="text-xl text-stables-700 max-w-4xl mx-auto leading-relaxed mt-6">
              If you'd like to learn more about our party packages, pricing, or have any questions, 
              please don't hesitate to reach out to us. Just send us an email, and our friendly team 
              will be more than happy to provide you with all the information you need to plan a fantastic 
              and unforgettable horse ride and picnic party for your children.
            </p>
          </div>

                     {/* Time Slots */}
           <div className="grid md:grid-cols-2 gap-8 mb-16">
             <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-stables-200">
               <div className="bg-gradient-to-br from-stables-500 to-stables-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                 </svg>
               </div>
               <h3 className="text-2xl font-bold text-stables-800 mb-4">Morning Session</h3>
               <p className="text-3xl font-bold text-stables-600 mb-2">10:00 - 13:00</p>
               <p className="text-stables-700">Perfect for early risers and morning adventures</p>
             </div>
             <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-stables-200">
               <div className="bg-gradient-to-br from-stables-500 to-stables-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                 </svg>
               </div>
               <h3 className="text-2xl font-bold text-stables-800 mb-4">Afternoon Session</h3>
               <p className="text-3xl font-bold text-stables-600 mb-2">14:00 - 17:00</p>
               <p className="text-stables-700">Ideal for afternoon fun and golden hour experiences</p>
             </div>
           </div>
        </div>
      </section>

      {/* Interactive Party Selection */}
      <section className="py-20 bg-earth-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-stables-800 mb-6">Choose Your Party Package</h2>
            <p className="text-xl text-stables-700 max-w-3xl mx-auto">
              Select from our themed party packages, each designed to create unforgettable memories
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {partyPackages.map((pkg) => (
              <button
                key={pkg.id}
                onClick={() => setActiveTab(pkg.id)}
                className={`px-6 py-3 rounded-lg font-semibold text-base transition-all duration-300 transform hover:scale-105 ${
                  activeTab === pkg.id
                    ? `bg-gradient-to-r ${pkg.color} text-white shadow-xl`
                    : 'bg-white text-stables-700 hover:bg-stables-50 border-2 border-stables-200'
                }`}
              >
                {pkg.title}
              </button>
            ))}
          </div>

          {/* Active Package Content */}
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-3xl font-bold text-stables-800 mb-8">{activePackage.title}</h3>
              <div className="space-y-6">
                                 {activePackage.features.map((feature, index) => (
                   <div key={index} className="group relative bg-white rounded-3xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                     <div>
                       <h4 className="text-xl font-bold text-stables-800 mb-2">{feature.title}</h4>
                       <p className="text-stables-700 leading-relaxed">{feature.description}</p>
                     </div>
                   </div>
                 ))}
              </div>
            </div>
            <div className="relative group">
              <div className={`absolute inset-0 bg-gradient-to-r ${activePackage.color} rounded-3xl sm:rotate-3 sm:group-hover:rotate-6 transition-transform duration-300`}></div>
              <img
                src={activePackage.image}
                alt={`${activePackage.title} party setup`}
                className="relative rounded-3xl shadow-2xl sm:-rotate-3 sm:group-hover:-rotate-6 transition-transform duration-300 w-full aspect-[4/3] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

             {/* Additional Information */}
       <section className="py-20 bg-cream-50">
         <div className="max-w-6xl mx-auto px-4">
           <div className="text-center mb-12">
             <h3 className="text-3xl font-bold text-stables-800 mb-4">Important Information</h3>
             <p className="text-xl text-stables-700">Please review our policies and guidelines</p>
           </div>
           <div className="grid md:grid-cols-3 gap-8">
             <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-stables-200">
               <div className="bg-gradient-to-br from-green-500 to-green-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                 </svg>
               </div>
               <h4 className="text-xl font-bold text-stables-800 mb-3">Allowed Items</h4>
               <p className="text-stables-700">Party packs & cake for children. Own cooldrinks welcome.</p>
             </div>
             <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-stables-200">
               <div className="bg-gradient-to-br from-red-500 to-red-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                 </svg>
               </div>
               <h4 className="text-xl font-bold text-stables-800 mb-3">Not Allowed</h4>
               <p className="text-stables-700">No alcohol. No outside catering.</p>
             </div>
             <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-stables-200">
               <div className="bg-gradient-to-br from-stables-500 to-stables-600 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                 <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                 </svg>
               </div>
               <h4 className="text-xl font-bold text-stables-800 mb-3">Contact Us</h4>
               <p className="text-stables-700">Contact us for pricing and availability</p>
             </div>
           </div>
         </div>
       </section>

      {/* Booking Form Section */}
      <section className="py-20 bg-cream-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white rounded-3xl shadow-xl border border-stables-200 overflow-hidden">
            <div className="bg-gradient-to-r from-stables-600 to-stables-700 p-10 text-white text-center">
              <h2 className="text-4xl font-bold mb-3">Book Your Party</h2>
              <p className="text-xl text-stables-100">Fill in our booking form and we'll get back to you to confirm your date</p>
            </div>
            <div className="p-10">
              <div className="grid md:grid-cols-3 gap-6 mb-10">
                <div className="text-center">
                  <div className="bg-stables-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-stables-700 font-bold text-lg">1</span>
                  </div>
                  <p className="font-semibold text-stables-800 mb-1">Fill in the form</p>
                  <p className="text-stables-600 text-sm">Choose your package, date, and guest details</p>
                </div>
                <div className="text-center">
                  <div className="bg-stables-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-stables-700 font-bold text-lg">2</span>
                  </div>
                  <p className="font-semibold text-stables-800 mb-1">We confirm availability</p>
                  <p className="text-stables-600 text-sm">Our team will reach out to confirm your booking</p>
                </div>
                <div className="text-center">
                  <div className="bg-stables-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-stables-700 font-bold text-lg">3</span>
                  </div>
                  <p className="font-semibold text-stables-800 mb-1">Party time!</p>
                  <p className="text-stables-600 text-sm">Show up and enjoy an unforgettable celebration</p>
                </div>
              </div>
              <div className="text-center">
                <a
                  href="https://form.jotform.com/232222569550050"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-gradient-to-r from-stables-600 to-stables-700 hover:from-stables-700 hover:to-stables-800 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Complete Booking Form
                </a>
                <p className="text-stables-500 text-sm mt-4">Opens in a new tab — takes less than 2 minutes</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-stables-600 text-white">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold mb-6">Ready to Plan Your Party?</h2>
          <p className="text-xl mb-8">
            Contact us to discuss your party requirements and create an unforgettable celebration for your child.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:info@thestableshorserides.co.za?subject=Stable Party Enquiry"
              className="bg-cream-50 text-stables-800 hover:bg-cream-100 px-6 py-3 rounded-lg text-base font-semibold transition-colors duration-300"
            >
              Email Us
            </a>
            <a
              href="tel:+27699464074"
              className="bg-transparent border-2 border-white text-white px-6 py-3 rounded-lg text-base font-semibold hover:bg-white hover:text-stables-600 transition-colors duration-300"
            >
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Parties; 